/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SchnellauswahlDto } from '../../models/schnellauswahl-dto';
import { UpdateSchnellauswahlDto } from '../../models/update-schnellauswahl-dto';

export interface UpdateSchnellauswahl$Json$Params {

/**
 * ID der Schnellauswahl die bearbeitet werden soll
 */
  schnellauswahlId: string;
  
    /**
     * Daten der zu bearbeitenden Schnellauswahl
     */
    body?: UpdateSchnellauswahlDto
}

export function updateSchnellauswahl$Json(http: HttpClient, rootUrl: string, params: UpdateSchnellauswahl$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SchnellauswahlDto>> {
  const rb = new RequestBuilder(rootUrl, updateSchnellauswahl$Json.PATH, 'put');
  if (params) {
    rb.path('schnellauswahlId', params.schnellauswahlId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SchnellauswahlDto>;
    })
  );
}

updateSchnellauswahl$Json.PATH = '/v1/schnellauswahl/{schnellauswahlId}';
